export default {
    created(){
        const vm = this;

        const registerEventProxy = (eventName) => { 
            vm.eventProxies[eventName] = function(){
                vm.$emit(eventName, ...arguments);
            };
        };
        
        //Vue, for some vague reason, errors when directly invoking $emit(event, ...arguments)
        registerEventProxy('click');
        registerEventProxy('dblclick');
        registerEventProxy('contextmenu');
        registerEventProxy('mouseover');
        registerEventProxy('mouseout');
        registerEventProxy('mousedown');
        registerEventProxy('mouseup');
        registerEventProxy('maxConnections');
        
        vm.referenceParameters = {
            anchor: 'Continuous',
            connector: ["Bezier", { curviness: 50 }],
            
            //Upon connecting; our connector is disabled
            //thus we should start with our disabled stroke
            connectorStyle: { strokeWidth: 6, stroke: vm.disabledConnectorStroke },
            maxConnections: 1,
            
            //Required for Panzoom exclusion
            cssClass: 'composer-component'
        };
    },
    data: () => ({
        eventProxies: {},
        referenceParameters: null,
        enabledConnectorStroke: '#BDB6B8',
        disabledConnectorStroke: '#CCC'
    }),
    props: {
        jsPlumbInstance: {
            type: Object,
            required: true
        }
    }
};